import { useState } from 'react';
import { Box, Button, Typography, Popover, MapOutlinedIcon } from 'src/components';
import { useIsMobile } from 'src/hooks';
import { MAP_STYLES } from 'src/data';

export default function MapStyleSelector({ mapStyle, setMapStyle }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const isMobile = useIsMobile();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);

  const handleSelect = (id) => {
    setMapStyle(id);
    handleClose();
  };

  return (
    <>
      <Button 
        variant="text"
        disableRipple
        onClick={handleClick} 
        sx={{ borderRadius: 2, flexDirection: 'row', p: 1, gap: 1 }}>
        <MapOutlinedIcon />
        <Typography variant="body2" fontWeight={600}>Map</Typography>
      </Button>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            p: 2,
            borderRadius: 3,
            width: isMobile ? 300 : 400,
            overflowX: isMobile ? 'visible' : 'auto',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: 2
          }
        }}
      >
        {MAP_STYLES.map(({ id, label, image }) => (
          <Box
            key={id}
            onClick={() => handleSelect(id)}
            sx={{
              cursor: 'pointer',
              position: 'relative',
              borderRadius: 2,
              overflow: 'hidden',
              minWidth: 100,
              height: 70,
              flexShrink: 0,
              border: mapStyle === id ? '2px solid #000' : '2px solid transparent',
              transition: '0.2s',
              '&:hover': {
                opacity: 0.8
              }
            }}
          >
            <img src={image} alt={label} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                background: 'rgba(0,0,0,0.5)',
                color: 'white',
                textAlign: 'center',
                fontSize: 12,
                py: 0.5
              }}
            >
              {label}
            </Box>
          </Box>
        ))}
      </Popover>
    </>
  );
}
